export default __webpack_public_path__ + "static/media/password-notification.fdb19928.svg";